import {throwError as observableThrowError,  Observable ,  BehaviorSubject } from 'rxjs';
import {take, filter, catchError, switchMap, finalize, tap, map} from 'rxjs/operators';
import { Injectable,  isDevMode } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from "@angular/common/http";
import { AuthenticationService } from '../_services';
import { environment } from 'src/environments/environment';
import { Payload } from '../_models';

declare const $ : any;

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    requestCount : number = 0;
    isRefreshingToken: boolean = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    errorCount : number = 0;

    constructor(
      private auth : AuthenticationService
      ) {

      }

      intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

        // if (this.auth.currentUserValue) {
        //   console.log(this.requestCount + ' : ' + ((new Date(this.auth.currentUserValue.payload.exp * 1000 ).valueOf()  - new Date().valueOf()) / 1000)  / 60);
        // } else {
        //   console.log(this.requestCount);
        // }


        if ( this.needAuth(req) && this.shouldRefreshToken() && ! this.isRefreshingToken ){
          // console.log('shouldRefreshToken : refreshing...');
    
          this.tokenSubject.next(null);
          this.isRefreshingToken = true;
    
          return this.auth.refreshAccessToken().pipe(
            switchMap ( token  => {
              this.tokenSubject.next(token);            
              return next.handle(this.addToken(req, token));
            }),
            finalize(() => {
              this.requestCount = 0;
              this.isRefreshingToken = false;
            })
          );

        } else if ( this.needAuth(req) && this.isRefreshingToken && ! ( req.url.endsWith('refresh') || req.url.endsWith('logout')) ) {
          return this.tokenSubject.pipe(         
            filter(token => token != null),
            take(1),
            switchMap(token => {
                return next.handle(this.addToken(req, token));
            })
          );
        } 

      return next.handle(this.addToken(req, this.auth.getAccessToken())).pipe(
        catchError( error => {
          if (error instanceof HttpErrorResponse) {
              switch ((<HttpErrorResponse>error).status) {
                  case 401: 
                   //20250602 axa if ( ! ( req.url.endsWith('logout') || req.url.endsWith('login')) ) {
                    if (!(req.url.endsWith('logout') || req.url.endsWith('login') || req.url.endsWith('loginaxa') || req.url.endsWith('reloginaxa') || req.url.includes('loginaxa/') || req.url.includes('relogin/'))) {
                        return this.auth.logout();
                    } 
                    this.requestCount = 0;
                    this.isRefreshingToken = false;
                    return observableThrowError(error);
                  case 404:  // notfound (nom d'usauri)
                  case 409:  // conflict (adreçces)
                  case 416:  // Requested Range Not Satisfiable (validació correu, codi postal)
                  case 503:  // bussy (catalog processing)
                    return observableThrowError(error);
                  case 500: // serverError  (force logout at first error)
                    this.isRefreshingToken = false;
                    this.manageError(error, true);
                    return observableThrowError(error);
                  default:
                    // this.isRefreshingToken = false;
                    // this.manageError(error);
                    return observableThrowError(error);
              }
          } else {
              this.isRefreshingToken = false;
              this.manageError(error);
              return observableThrowError(error);
          }
        }),
      );

    }

    manageError (error : any, forceLogOff? : boolean){
      this.errorCount +=1;
      if (this.errorCount >= environment.MAX_ERROR_COUNT || forceLogOff ) {
        this.errorCount = 0;
        $('.modal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('#modal-message-connectionError').modal('show'); 
      }
    }

    sessionExpired (){
      this.errorCount = 0;
      this.isRefreshingToken = false;
      this.requestCount = 0;
      $('.modal').modal('hide');
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      $('#modal-message-sessionExpired').modal('show'); 
    }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
      this.requestCount += 1;
      if ( this.needAuth(req) && ! req.headers.has('Authorization')) {
        return req.clone({ setHeaders: { Authorization: 'Bearer ' + token }})
      }
      return req;    
  }

  private shouldRefreshToken(): boolean {
    // Los token AxA no se pueden refrescar
    // if ( this.auth && this.auth.isLogedUser && this.auth.isAxA){
    //   return false;
    // }

    if ( this.auth && this.auth.isLogedUser && this.tokenExpired(this.auth.currentUserValue.payload) ){
      this.sessionExpired();
      return false;
    }
    if ( this.auth && this.auth.isLogedUser ){
        //20250602 axa inici return !this.tokenExpired(this.auth.currentUserValue.payload) && (this.requestCount > environment.JWT.REFRESH_TOKEN_MAX_REQUEST_COUNT || this.tokenWillExpire(this.auth.currentUserValue.payload));
        return !this.tokenExpired(this.auth.currentUserValue.payload)
          && (
          this.requestCount > environment.JWT.REFRESH_TOKEN_MAX_REQUEST_COUNT
          || (
            // si es axa, no es pot refrescar el token, no tenim en compte si expirara aviat.
            !this.auth.isAxA && this.tokenWillExpire(this.auth.currentUserValue.payload)
          )
        );
      //20250602 axa final

    }
    return false;
  }

  private tokenWillExpire( payload : Payload) : boolean {
    // console.log(((new Date(payload.exp * 1000 ).valueOf()  - new Date().valueOf()) / 1000)  / 60);

    return ((new Date(payload.exp * 1000).valueOf() - new Date().valueOf()) / 1000) / 60 < environment.JWT.REFRESH_TOKEN_EXPIRY_MINUTES;
    // TEST 
    // console.log(((new Date(payload.exp * 1000 ).valueOf()  - new Date().valueOf()) / 1000)  / 60);
    // return ((new Date(payload.exp * 1000 ).valueOf()  - new Date().valueOf()) / 1000)  / 60  < 29.8;
  }

  private tokenExpired( payload : Payload) : boolean {
    if (payload){
      return ((new Date(payload.exp * 1000 ).valueOf()  - new Date().valueOf()) / 1000)  / 60  <= 0;
      // TEST
      // return ((new Date(payload.exp * 1000 ).valueOf()  - new Date().valueOf()) / 1000)  / 60  < 29.8;
    }
    return false;
  }

  private needAuth(req:  HttpRequest<any>){

    if ( req.url.indexOf(environment.API_ENDPOINT) > -1 && ( req.url.indexOf('/api/utils') > -1 && ! req.url.endsWith('factura')  ) )
    {
      // console.log( req.url + ' -> no  need auth')
      return false;
    } else if ( req.url.indexOf('/api/carrusel') > -1 ){
      // al demanar el carrusel passar token si l'usuari esta logat, sino no
      return this.auth.isLogedUser;
    } else if (req.url.indexOf(environment.API_ENDPOINT) > -1 ) {
      // console.log( req.url + ' -> yes need auth')
      return true;
    }
    // console.log( req.url + ' -> no need auth')
    return false;
  }
  
}
